<p-dialog modal="true" styleClass="atlas-dialog-l wl-transactions-grid-apply-payments-dialog" [closable]="false"
  [(visible)]="show">
  <ng-template pTemplate="header">
    <h3>{{ 'revenue.transactions-grid.unapplied-payments.apply.header' | translate | titlecase }}</h3>
  </ng-template>
  <wl-multi-invoice-payment [invoiceNumbers]="invoiceNumbers"
    [unappliedPaymentsBalance]="unappliedPaymentsBalance"></wl-multi-invoice-payment>
  <ng-template pTemplate="footer">
    <div class="grid cols-1fr-1fr w-100" style="margin: 0">
      <div [hidden]="!unappliedPaymentsBalance" class="f-wb">
        {{ 'revenue.transactions-grid.unapplied-payments.unapplied-total-label' | translate | titlecase }}
        &nbsp;
        {{ unappliedPaymentsBalance | currency }}
      </div>
      <div class="flex row-collapse content-end">
        <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="this.show = false">
          {{ 'common.cancel' | translate | uppercase }}
        </button>
        <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="isSaving" (click)="saveClicked()">
          <span *ngIf="!isSaving">{{ 'common.save' | translate | uppercase }}</span>
          <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>